export { default } from './MapRC';
